module.exports = __webpack_public_path__ + "img/zorunlu-trafik-sigortasi.dabb0999.png";